import React, { useState } from "react";
import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Input,
  HStack,
  Spinner,
  Center,
  useToast,
  Heading,
  Text,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { useAdminSettings, Setting, useCreateSetting } from "api/admin";

export default function Settings(): JSX.Element {
  const { data, isLoading, isError } = useAdminSettings();
  const createMut = useCreateSetting();
  const toast = useToast();

  const [key, setKey] = useState("");
  const [val, setVal] = useState("");

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!key || !val) return;
    try {
      await createMut.mutateAsync({ key, value: val });
      toast({ title: "Setting created", status: "success", isClosable: true });
      setKey("");
      setVal("");
    } catch (e) {
      toast({ title: "Failed to create setting", status: "error", isClosable: true });
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Card p="20px" mb="20px">
        <Heading size="md" mb="4">Create / Update Setting</Heading>
        <form onSubmit={handleCreate}>
          <HStack spacing={4} align="flex-end">
            <FormControl>
              <FormLabel>Key</FormLabel>
              <Input value={key} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setKey(e.target.value)} />
            </FormControl>
            <FormControl>
              <FormLabel>Value</FormLabel>
              <Input value={val} onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => setVal(e.target.value)} />
            </FormControl>
            <Button type="submit" colorScheme="brand" isLoading={createMut.isLoading}>Save</Button>
          </HStack>
        </form>
      </Card>

      <Card p="20px">
        <Heading size="md" mb="4">Global Settings</Heading>
        {isLoading ? (
          <Center p="40px"><Spinner /></Center>
        ) : isError ? (
          <Center p="40px"><Text color="red.500">Failed to load data.</Text></Center>
        ) : !data?.length ? (
          <Center p="40px"><Text>No data found.</Text></Center>
        ) : (
          <Box overflowX="auto">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Key</Th>
                  <Th>Value</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.map((s: Setting) => (
                  <Tr key={s.id}>
                    <Td fontWeight="bold">{s.key}</Td>
                    <Td>{s.value}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        )}
      </Card>
    </Box>
  );
}
